import { Card, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import '@features/Incentive/incentive.css';
import { DashboardSelector } from '../store/DashboardSelector';
import { useEffect, useMemo } from 'react';
import { GetTransactionDashboard } from '../business/DashboardBusiness';
import { TransactionBoxStatus } from 'common/constants';
export const TransactionNewDashboard = () => {
  const dispatch = useDispatch();
  const dashboardState = useSelector(DashboardSelector);
  const data = useMemo(
    () => dashboardState.TransactionNewDashboardList || [],
    [dashboardState.TransactionNewDashboardList]
  );

  const columns = [
    {
      title: 'Reference no.',
      dataIndex: 'RefNo',
      key: 'RefNo',
    },
    {
      title: 'Name',
      dataIndex: 'CompleteName',
      key: 'CompleteName',
    },
    {
      title: 'Contact no.',
      dataIndex: 'ContactNo',
      key: 'ContactNo',
    },
    {
      title: 'Address',
      dataIndex: 'CompleteAddress',
      key: 'CompleteAddress',
    },
    {
      title: 'Type',
      dataIndex: 'TransactionType',
      key: 'TransactionType',
      sorter: (a, b) => a.TransactionType.localeCompare(b.TransactionType),
    },
    {
      title: 'No. of boxes',
      dataIndex: 'Qty',
      key: 'Qty',
      sorter: (a, b) => a.Qty.localeCompare(b.Qty),
    },
    {
      title: 'Created date',
      dataIndex: 'CreatedDate',
      key: 'CreatedDate',
      sorter: (a, b) => a.CreatedDate.localeCompare(b.CreatedDate),
    },
  ];
  useEffect(() => {
    const fetchData1 = async () => {
      await dispatch(GetTransactionDashboard(TransactionBoxStatus.NW));
    };

    fetchData1();
  }, [dispatch]);

  return (
    <div className="App">
      <Card>
        <Table dataSource={data} columns={columns} pagination={{ pageSize: 100 }} />
      </Card>
    </div>
  );
};
